import { createAnalyticsGroup } from 'js/lib/analytics'
import { initializeAnalyticsTracking } from 'js/lib/analytics-tracking.mjs'
import { on } from 'js/lib/events'

initializeAnalyticsTracking(on, createAnalyticsGroup, '.js-c-ui-typography-a-tracking', () => window.location.href)
